import axios, { AxiosRequestConfig } from "axios"
import { reactMainApiBaseUrl, customerKey, msalMainApiRequest } from "../../../configuration"
import { IPublicClientApplication } from '@azure/msal-browser'
import GetAccessToken from '../../functions/security/AccessTokenProvider'
import IAction from "../../interfaces/actions/action"

export default async function GetActions(publicClientApplication:IPublicClientApplication, customerID:string, sensorID:string, spotID:string, entityType:string, entityID:string, entityLocalID:string):Promise<IAction[]> {

  const accessToken = await GetAccessToken(publicClientApplication, msalMainApiRequest)
  const parameters = await createRequestParameters(customerID, sensorID, spotID, entityType, entityID, entityLocalID)
  const requestConfiguration:AxiosRequestConfig = {
    url: (reactMainApiBaseUrl(customerID) + '/actions'),
    method: 'GET',
    params: parameters,
    headers: { Authorization: ('Bearer ' + accessToken)}
  }

  return axios(requestConfiguration)
    .then(result => result.data)
    .catch(event => Error("Could not retrieve actions from Sense React Api.\n\n" + event))
}

const createRequestParameters = async (customerID:string, sensorID:string, spotID:string, entityType:string, entityID:string, entityLocalID:string) => {

  const parameters = new URLSearchParams()

  parameters.append('code', customerKey)
  parameters.append('id', customerID)
  parameters.append('sensor-id', sensorID)
  parameters.append('spot-id', spotID)
  parameters.append('entity-type', entityType)
  parameters.append('entity-local-id', ((entityLocalID) ? entityLocalID : entityID))

  return parameters
}